export function isNotificationShownToday() {
  const cookieName = 'cookieNotificationShown';
  const lastShown = getCookie(cookieName);

  if (lastShown) {
    const today = new Date();
    return today.toDateString() === new Date(lastShown).toDateString();
  }

  return false;
}

export function setCookie(name: string | null, value: string, days: number) {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + days);
  document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
}

function getCookie(name: string | null) {
  const cookieValue = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return cookieValue ? cookieValue[2] : null;
}
